const Divider = () => {
  return <div className="pt-px my-4 bg-grey-lighter" data-testid="divider" />;
};

export default Divider;
